import React from "react";
import { useTranslation } from "react-i18next";
import { StepComponentProps } from "../../components/MultiStepGradeModal";
import { RubricGeneratorCreateRequestDto } from "@packages/api/madlenAPI.schemas";

export const AssignmentInstructionsStep: React.FC<
  StepComponentProps<RubricGeneratorCreateRequestDto>
> = ({ data, onDataChange, themeColor }) => {
  const { t } = useTranslation();

  const handleInstructionsChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
  ) => {
    onDataChange({ assignmentInstructions: e.target.value });
  };

  const instructionTips = [
    {
      icon: "🎯",
      title: t("rubric.assignment.tip1.title", "Açık Hedefler"),
      description: t(
        "rubric.assignment.tip1.description",
        "Öğrencilerin ne yapması gerektiğini net bir şekilde belirtin",
      ),
    },
    {
      icon: "📏",
      title: t("rubric.assignment.tip2.title", "Ölçütler"),
      description: t(
        "rubric.assignment.tip2.description",
        "Kelime sayısı, format, kaynak sayısı gibi somut gereksinimleri ekleyin",
      ),
    },
    {
      icon: "📅",
      title: t("rubric.assignment.tip3.title", "Zaman Çizelgesi"),
      description: t(
        "rubric.assignment.tip3.description",
        "Teslim tarihi, ara aşamalar ve önemli tarihler",
      ),
    },
    {
      icon: "🎨",
      title: t("rubric.assignment.tip4.title", "Format"),
      description: t(
        "rubric.assignment.tip4.description",
        "Yazılı rapor, sunum, dijital format gibi beklentileri açıklayın",
      ),
    },
  ];

  return (
    <div className="space-y-6">
      <div className="text-center mb-6">
        <h2
          className={`text-2xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-${themeColor}-600 to-${themeColor}-800 dark:from-${themeColor}-400 dark:to-${themeColor}-600`}
        >
          {t("rubric.steps.assignment.title", "Ödev Talimatları")}
        </h2>
        <div className="flex items-center justify-center gap-2 mt-2">
          <p className="text-gray-600 dark:text-gray-400">
            {t(
              "rubric.steps.assignment.description",
              "Ödeviniz hakkında detaylı bilgi verin.",
            )}
          </p>
        </div>
      </div>

      {/* Instructions Tips */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {instructionTips.map((tip, index) => (
          <div
            key={index}
            className={`p-4 rounded-lg border-2 border-${themeColor}-200 dark:border-${themeColor}-800 bg-gradient-to-r from-${themeColor}-50 to-${themeColor}-100 dark:from-${themeColor}-900/30 dark:to-${themeColor}-800/30`}
          >
            <div className="flex items-center gap-3 mb-2">
              <span className="text-2xl">{tip.icon}</span>
              <h3 className="font-semibold text-gray-800 dark:text-gray-200">
                {tip.title}
              </h3>
            </div>
            <p className="text-sm text-gray-600 dark:text-gray-400">
              {tip.description}
            </p>
          </div>
        ))}
      </div>

      {/* Assignment Instructions Textarea */}
      <div className="space-y-4">
        <div>
          <label
            htmlFor="assignmentInstructions"
            className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
          >
            {t("rubric.assignment.instructions.label", "Ödev Talimatları")}
            <span className="text-red-500 ml-1">*</span>
          </label>
          <textarea
            id="assignmentInstructions"
            value={data.assignmentInstructions || ""}
            onChange={handleInstructionsChange}
            rows={8}
            className={`w-full px-4 py-3 border-2 border-${themeColor}-200 dark:border-${themeColor}-800 rounded-lg focus:border-${themeColor}-500 dark:focus:border-${themeColor}-400 focus:outline-none focus:ring-2 focus:ring-${themeColor}-500/20 dark:focus:ring-${themeColor}-400/20 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 resize-none transition-all duration-200`}
            placeholder={t(
              "rubric.assignment.instructions.placeholder",
              "Öğrenciler ne öğrenmeli veya neye ulaşmalı? Gereksinimleri: Kelime sayısı, format, kaynak sayısı vb. Zaman Çizelgesi: Teslim tarihi, ara aşamalar ve önemli tarihler Uygun atıf formatı gereklidir.",
            )}
          />
        </div>
      </div>
    </div>
  );
};
